// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageCheckoutV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageCheckoutV2Query = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, description?: string | null | undefined, insideMapsProjectId?: string | null | undefined, maxInsideMapsRooms: number, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }>, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, isInsideMapsRoom?: boolean | null | undefined, insideMapsRoomOrder?: number | null | undefined, location: { __typename?: 'Location', id: string, name: string }, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
       }> } };

export type SavePlanPackageCheckoutV2MutationVariables = Types.Exact<{
  input: Types.SavePlanPackageInput;
}>;


export type SavePlanPackageCheckoutV2Mutation = { __typename?: 'Mutation', savePlanPackage: { __typename?: 'SavePlanPackageResult', planPackage: { __typename?: 'PlanPackage', id: string, description?: string | null | undefined, insideMapsProjectId?: string | null | undefined, maxInsideMapsRooms: number, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }>, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, isInsideMapsRoom?: boolean | null | undefined, insideMapsRoomOrder?: number | null | undefined, location: { __typename?: 'Location', id: string, name: string }, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
          | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
          | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
          | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
         }> } } };

export type SavePlanPackageCheckoutRoomsV2MutationVariables = Types.Exact<{
  inputs: Array<Types.SaveReadyPlanLocationInput> | Types.SaveReadyPlanLocationInput;
}>;


export type SavePlanPackageCheckoutRoomsV2Mutation = { __typename?: 'Mutation', saveReadyPlanLocations: { __typename?: 'SaveReadyPlanLocationBulkResult', readyPlanLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, isInsideMapsRoom?: boolean | null | undefined, insideMapsRoomOrder?: number | null | undefined, location: { __typename?: 'Location', id: string, name: string }, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
       }> } };

export type PlanPackageCheckoutV2_PlanPackageFragment = { __typename?: 'PlanPackage', id: string, description?: string | null | undefined, insideMapsProjectId?: string | null | undefined, maxInsideMapsRooms: number, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, type: { __typename?: 'ReadyPlanAssetTypeDetail', code: Types.ReadyPlanAssetType }, asset: { __typename?: 'Asset', id: string, downloadUrl: string } }>, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, isInsideMapsRoom?: boolean | null | undefined, insideMapsRoomOrder?: number | null | undefined, location: { __typename?: 'Location', id: string, name: string }, readyPlan:
      | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
     }> };

export type PlanPackageCheckoutV2_LocationFragment = { __typename?: 'ReadyPlanLocation', id: string, isInsideMapsRoom?: boolean | null | undefined, insideMapsRoomOrder?: number | null | undefined, location: { __typename?: 'Location', id: string, name: string }, readyPlan:
    | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
    | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
    | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
    | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
   };

export const PlanPackageCheckoutV2_LocationFragmentDoc = gql`
    fragment PlanPackageCheckoutV2_Location on ReadyPlanLocation {
  id
  isInsideMapsRoom
  insideMapsRoomOrder
  location {
    id
    name
  }
  readyPlan {
    id
    aggregateDraft {
      id
    }
  }
}
    `;
export const PlanPackageCheckoutV2_PlanPackageFragmentDoc = gql`
    fragment PlanPackageCheckoutV2_PlanPackage on PlanPackage {
  id
  version {
    id
  }
  canEdit {
    ...PotentialOperationDetails
  }
  description
  insideMapsProjectId
  maxInsideMapsRooms
  assets {
    id
    active
    type {
      code
    }
    asset {
      id
      downloadUrl
    }
  }
  roomLocations(filter: {locationType: [ROOM]}) {
    ...PlanPackageCheckoutV2_Location
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${PlanPackageCheckoutV2_LocationFragmentDoc}`;
export const PlanPackageCheckoutV2Document = gql`
    query PlanPackageCheckoutV2($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    ...PlanPackageCheckoutV2_PlanPackage
  }
}
    ${PlanPackageCheckoutV2_PlanPackageFragmentDoc}`;

/**
 * __usePlanPackageCheckoutV2Query__
 *
 * To run a query within a React component, call `usePlanPackageCheckoutV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageCheckoutV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageCheckoutV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageCheckoutV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables> & ({ variables: PlanPackageCheckoutV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>(PlanPackageCheckoutV2Document, options);
      }
export function usePlanPackageCheckoutV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>(PlanPackageCheckoutV2Document, options);
        }
// @ts-ignore
export function usePlanPackageCheckoutV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>;
export function usePlanPackageCheckoutV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageCheckoutV2Query | undefined, PlanPackageCheckoutV2QueryVariables>;
export function usePlanPackageCheckoutV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>(PlanPackageCheckoutV2Document, options);
        }
export type PlanPackageCheckoutV2QueryHookResult = ReturnType<typeof usePlanPackageCheckoutV2Query>;
export type PlanPackageCheckoutV2LazyQueryHookResult = ReturnType<typeof usePlanPackageCheckoutV2LazyQuery>;
export type PlanPackageCheckoutV2SuspenseQueryHookResult = ReturnType<typeof usePlanPackageCheckoutV2SuspenseQuery>;
export type PlanPackageCheckoutV2QueryResult = ApolloReactCommon.QueryResult<PlanPackageCheckoutV2Query, PlanPackageCheckoutV2QueryVariables>;
export const SavePlanPackageCheckoutV2Document = gql`
    mutation SavePlanPackageCheckoutV2($input: SavePlanPackageInput!) {
  savePlanPackage(input: $input) {
    planPackage {
      ...PlanPackageCheckoutV2_PlanPackage
    }
  }
}
    ${PlanPackageCheckoutV2_PlanPackageFragmentDoc}`;

/**
 * __useSavePlanPackageCheckoutV2Mutation__
 *
 * To run a mutation, you first call `useSavePlanPackageCheckoutV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanPackageCheckoutV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanPackageCheckoutV2Mutation, { data, loading, error }] = useSavePlanPackageCheckoutV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlanPackageCheckoutV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanPackageCheckoutV2Mutation, SavePlanPackageCheckoutV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanPackageCheckoutV2Mutation, SavePlanPackageCheckoutV2MutationVariables>(SavePlanPackageCheckoutV2Document, options);
      }
export type SavePlanPackageCheckoutV2MutationHookResult = ReturnType<typeof useSavePlanPackageCheckoutV2Mutation>;
export type SavePlanPackageCheckoutV2MutationResult = ApolloReactCommon.MutationResult<SavePlanPackageCheckoutV2Mutation>;
export const SavePlanPackageCheckoutRoomsV2Document = gql`
    mutation SavePlanPackageCheckoutRoomsV2($inputs: [SaveReadyPlanLocationInput!]!) {
  saveReadyPlanLocations(inputs: $inputs) {
    readyPlanLocations {
      ...PlanPackageCheckoutV2_Location
    }
  }
}
    ${PlanPackageCheckoutV2_LocationFragmentDoc}`;

/**
 * __useSavePlanPackageCheckoutRoomsV2Mutation__
 *
 * To run a mutation, you first call `useSavePlanPackageCheckoutRoomsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanPackageCheckoutRoomsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanPackageCheckoutRoomsV2Mutation, { data, loading, error }] = useSavePlanPackageCheckoutRoomsV2Mutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSavePlanPackageCheckoutRoomsV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanPackageCheckoutRoomsV2Mutation, SavePlanPackageCheckoutRoomsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanPackageCheckoutRoomsV2Mutation, SavePlanPackageCheckoutRoomsV2MutationVariables>(SavePlanPackageCheckoutRoomsV2Document, options);
      }
export type SavePlanPackageCheckoutRoomsV2MutationHookResult = ReturnType<typeof useSavePlanPackageCheckoutRoomsV2Mutation>;
export type SavePlanPackageCheckoutRoomsV2MutationResult = ApolloReactCommon.MutationResult<SavePlanPackageCheckoutRoomsV2Mutation>;